import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=7f35829c&scoped=true"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35829c",
  null
  
)

export default component.exports